<app-template [useCard]="true" [subTitle]="'Confirmar presença de Equipe de Governo'" [customSubtitleFontSize]="'18px'">
  <main class="d-flex justify-content-center">
    <ng-container [ngSwitch]="step">
      <app-autht-step-one *ngSwitchCase="1" [meeting]="meeting()"></app-autht-step-one>
      <app-autht-step-two *ngSwitchCase="2" [user]="user" [meeting]="meeting" [registration]="preRegistration" (onRegister)="onRegister($event)"></app-autht-step-two>
      <app-autht-step-three *ngSwitchCase="3" [preRegistration]="preRegistrationAuthority" [userInfo]="user"></app-autht-step-three>
    </ng-container>
  </main>
</app-template>
